import { LANDING_PAGE_CATEGORY, LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics/analyticsLandingPage';

export const numWord = ['one', 'two', 'three', 'four', 'five', 'six'];

export const sectionNames = numWord.slice(0, 4).map((n, i) => {
  const isEven = (i % 2 === 0);
  return {
    contentBody: `section_${n}_body_area`,
    imageAlt: `section_${n}_image_area_alt`,
    imageArea: `section_${n}_image_area`,
    position: (isEven ? 'left' : 'right'),
    theme: (isEven ? 'light' : 'dark'),
    title: `section_${n}_title`,
  };
});

export const relatedGuidesNames = numWord.map((n) => ({
  description: `related_guide_description_${n}`,
  thumbnail: `related_guide_image_${n}`,
  title: `related_guide_title_${n}`,
  url: `related_guide_url_${n}`,
}));

export const FAQImage = {
  imgSrc: 'https://blog.motorway.co.uk/wp-content/uploads/2022/11/Changes-2.png',
};

export const PAGE_SECTIONS = {
  DEALER_LOGOS: 'DEALER_LOGOS',
  FAQ: 'FAQ',
  HERO: 'HERO',
  HOW_IT_WORKS: 'HOW_IT_WORKS',
  RECENT_SALES: 'RECENT_SALES',
  RELATED_GUIDES: 'RELATED_GUIDES',
  STEPS: 'STEPS',
  TRUSTPILOT: 'TRUSTPILOT',
  USP: 'USP',
  VIDEO: 'VIDEO',
} as const;

const LANDINGPAGE_SECTION_EVENT_NAMES = {
  [PAGE_SECTIONS.DEALER_LOGOS]: LANDING_PAGE_SECTIONS_NAMES.DEALER_LOGOS,
  [PAGE_SECTIONS.FAQ]: LANDING_PAGE_SECTIONS_NAMES.FAQ,
  [PAGE_SECTIONS.HERO]: LANDING_PAGE_SECTIONS_NAMES.HERO,
  [PAGE_SECTIONS.HOW_IT_WORKS]: LANDING_PAGE_SECTIONS_NAMES.HOW_IT_WORKS,
  [PAGE_SECTIONS.RECENT_SALES]: LANDING_PAGE_SECTIONS_NAMES.RECENT_SALES,
  [PAGE_SECTIONS.RELATED_GUIDES]: LANDING_PAGE_SECTIONS_NAMES.RELATED_GUIDES,
  [PAGE_SECTIONS.STEPS]: LANDING_PAGE_SECTIONS_NAMES.STEPS,
  [PAGE_SECTIONS.TRUSTPILOT]: LANDING_PAGE_SECTIONS_NAMES.TRUSTPILOT_WIDGET,
  [PAGE_SECTIONS.USP]: LANDING_PAGE_SECTIONS_NAMES.USP,
  [PAGE_SECTIONS.VIDEO]: LANDING_PAGE_SECTIONS_NAMES.ADVERT,
} as const;

export const landingPageSectionLoadEvent = (sectionName: keyof typeof PAGE_SECTIONS) =>
  LANDING_PAGE_EVENTS.SECTION_LOAD({ name: LANDINGPAGE_SECTION_EVENT_NAMES[sectionName] });

export const howItWorksSectionAnalyticsConfig = {
  category: LANDING_PAGE_CATEGORY,
  name: LANDING_PAGE_SECTIONS_NAMES.HOW_IT_WORKS,
} as const;
